// Shared request shaping for every document editor (drawer Documents, record
// Documents section, Connections/Sources popover). New URLs must be strict
// Google links; a legacy row can edit title/source/pageRef without
// resubmitting (or rewriting) its historical URL.
import { parseGoogleDocument } from "../../../lib/projectDocumentLinks.js";

export const GOOGLE_URL_ERROR = "Paste a Google Drive link (https://drive.google.com or https://docs.google.com).";
export const TITLE_REQUIRED_ERROR = "Enter a title for this document.";

export function documentDraft(doc) {
  return doc
    ? { title: doc.title || "", source: doc.source || "Other", url: doc.url || "", pageRef: doc.pageRef || "", originalUrl: doc.url || "", originalTitle: doc.title || "" }
    : { title: "", source: "Google Drive", url: "", pageRef: "", originalUrl: null, originalTitle: "" };
}

/** Returns { error } or { payload }. */
export function buildDocumentPayload(draft, isNew) {
  const title = (draft?.title || "").trim();
  const url = (draft?.url || "").trim();
  const pageRef = (draft?.pageRef || "").trim() || null;
  const source = draft?.source || "Google Drive";
  if (isNew) {
    const parsed = parseGoogleDocument(url);
    if (!parsed) return { error: GOOGLE_URL_ERROR };
    if (!title) return { error: TITLE_REQUIRED_ERROR };
    return { payload: { url: parsed.url, title, source, pageRef } };
  }
  const payload = { source, pageRef };
  if (title) payload.title = title;
  else if (draft?.originalTitle) return { error: TITLE_REQUIRED_ERROR };
  if (url !== (draft?.originalUrl || "").trim()) {
    const parsed = parseGoogleDocument(url);
    if (!parsed) return { error: GOOGLE_URL_ERROR };
    payload.url = parsed.url;
  }
  return { payload };
}

/** Only a row whose stored URL parses as a strict Google link is trusted for preview/chips. */
export function trustedGoogle(doc) {
  return parseGoogleDocument(typeof doc?.url === "string" ? doc.url : "");
}

// Read-only compatibility for stored links. Never use this to authorize new
// submissions, Google previews or key chips.
export function historicalExternalUrl(value) {
  if (typeof value !== "string" || /[\\\u0000-\u001f\u007f]/.test(value)) return null;
  try {
    const url = new URL(value.trim());
    return ["http:", "https:"].includes(url.protocol) && !url.username && !url.password
      ? url.href : null;
  } catch { return null; }
}
